module.exports = __webpack_public_path__ + "static/6-309143356af7a294ab7278b6f7cb116c.jpeg";